export default __webpack_public_path__ + "static/media/redtiger-table.f762f0de.png";